import * as actions from '../../redux/actions';

import React from 'react';

import CommonService from '../../../../services/commonService';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export const AboutUsIconSection = props => {
  const operator = CommonService.getLocal('op');

  const renderIconsAndText = (item, key, length) => {
    return (
      <React.Fragment>
        <style>
          .borderRight-about-icons {'{'}
          border-right: 1px solid {getBorderColor(operator.operator_name)};{'}'}
        </style>
        <div
          className={
            operator.operator_name === 'expressonorte'
              ? key + 1 != length && (key + 1) % 5 != 0
                ? 'single-item-container borderRight-about-icons'
                : 'single-item-container'
              : key + 1 != length && (key + 1) % 3 != 0
              ? 'single-item-container borderRight-about-icons'
              : 'single-item-container'
          }
          style={
            operator.operator_name === 'expressonorte'
              ? { width: length <= 3 ? `${100 / length}%` : '20%' }
              : { width: length <= 3 ? `${100 / length}%` : '33%' }
          }
        >
          <div className="single-item">
            <div>
              <img src={item.image} alt="Giras de estudio" className="about-icon" />
            </div>
            <div className="font10">{item.caption}</div>
          </div>

          {/* { <div className="borderRight-about-icons"></div> : ' '} */}
        </div>
      </React.Fragment>
    );
  };

  return (
    <div className="themes-about-us-icon-section new-container mt10 ">
      <div className="about-us-icons-main-container">
        <div>
          {props.smallHeading && (
            <div className="font10 less-bold-text mb5">{props.smallHeading}</div>
          )}

          {props.boldHeading && (
            <div className="font13 bold-text mb5 black-text-color">{props.boldHeading}</div>
          )}
        </div>
        <div className="icons-container">
          {props.iconsAndTexts.map((item, key) => {
            return renderIconsAndText(item, key, props.iconsAndTexts.length);
          })}
        </div>
      </div>
    </div>
  );
};

const getBorderColor = name => {
  if (name === 'tepual') {
    return '#008137';
  }
  return '#b2b2b2';
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutUsIconSection);



// WEBPACK FOOTER //
// ./src/features/themes/common/about-us/AboutUsIconSection.js